"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Switch = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Switch = _ref => {
  let {
    checked,
    color,
    disabled,
    onChange,
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_core.Switch, {
    color: color,
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    className: className
  });
};
exports.Switch = Switch;
Switch.propTypes = {
  /**
   * Se `true` o componente será checado
   */
  checked: _propTypes.default.bool,
  /**
   * Cor do switch
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']).isRequired,
  /**
   * Se `true` o componente será desativado
   */
  disabled: _propTypes.default.bool,
  /**
   * Retorna uma chamada quando o estado é alterado
   */
  onChange: _propTypes.default.func,
  /**
   * Classe css para o botão
   */
  className: _propTypes.default.string
};
Switch.defaultProps = {
  checked: null,
  disabled: null,
  onChange: null,
  className: null
};
var _default = exports.default = Switch;